// extracted by mini-css-extract-plugin
export var accountSearchCriterion = "account-search__criterion_olBsoVLt5BFb4uddbaQk";